import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface MinimalVent {
  name: string | undefined;
  starts: string;
}

const formSlice = createGenericFormSlice({
  name: "createVent",
  initialState: {} as SliceState<MinimalVent>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createVentReducer = formSlice.reducer;
export default createVentReducer;
